// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info_info__5G33f {
    display: flex;
    align-items: center;
    grid-gap: 10px;
}

.info_iconPlaceholder__2\\+\\+76 {
    display: inline-block;
    width: 20px;
}

.info_highlight__HuDVb {
    color: var(--primary-color);
    /*font-weight: 700;*/
}
`, "",{"version":3,"sources":["webpack://./src/pages/LegalStructures/components/Info/info.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB","sourcesContent":[".info {\n    display: flex;\n    align-items: center;\n    grid-gap: 10px;\n}\n\n.iconPlaceholder {\n    display: inline-block;\n    width: 20px;\n}\n\n.highlight {\n    color: var(--primary-color);\n    /*font-weight: 700;*/\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `info_info__5G33f`,
	"iconPlaceholder": `info_iconPlaceholder__2++76`,
	"highlight": `info_highlight__HuDVb`
};
export default ___CSS_LOADER_EXPORT___;
